import Audience from '@/classes/audience'
import Config from '@/config'
import storage from '@/services/storage'
import socket from '@/socket'
import Util from '@/util'
import * as Sentry from '@sentry/vue'
import { getMessageSubscriber } from '@/websocket/subscribers/legacy/main.websocket.subscriber'

export default {
  handleInitSocket(res, editor) {
    editor.handleDataQuestions(res.body.presentation)

    if (editor.isConnectSocket) {
      // eslint-disable-next-line promise/catch-or-return
      editor.$http
        .get(Config.api.getPresentationFromCdn + editor.uniqueAccessCode)
        .then((dataPresentation) => {
          if (!dataPresentation.body.presenting) {
            editor._handleDataReconnect(dataPresentation)
            return
          }

          if (!dataPresentation.body.slideActiveCacheUrl) {
            return
          }

          const urlCdn = dataPresentation.body.slideActiveCacheUrl

          // eslint-disable-next-line promise/no-nesting
          editor.$http.get(urlCdn)
            .then((res) => {
              res.body = editor.tryParseBody(res.bodyText, dataPresentation.body.id)
              res.body.presentation = dataPresentation.body
              editor._handleDataReconnect(res)
            })
            .catch((err) => {
              // eslint-disable-next-line promise/catch-or-return
              editor.$http.get(Config.api.getPresentation + editor.uniqueAccessCode)
                .then((dataUnhandle) => {
                  editor._handleDataReconnect(dataUnhandle)
                })

              if (Sentry && err.status) {
                err.from = 'Audience reconnect'
                Sentry.captureException(JSON.stringify(err))
              }
            })
        }, (err) => {
          if (err.status === 400) {
            editor.$router.push({
              name: 'home',
              query: { error: true },
            })
          }
        })

      editor.$store.state.socketDisconnect = false
      Util.mixpanelTrack(
        'System Status',
        'Connection is back',
        editor.$store.state.presentation.id,
        { nonInteraction: true },
      )

      return
    }

    socket.subscribe(editor.uniqueAccessCode.toLowerCase(), (doc) => {
      const messageSubscriber = getMessageSubscriber(doc.type)
      if (messageSubscriber && typeof messageSubscriber === 'function') {
        messageSubscriber(doc, editor)
      }
    })

    editor.isConnectSocket = true
    const self = editor
    socket.getSocket().on('disconnect', () => {
      self.$store.state.socketDisconnect = true
      Util.mixpanelTrack(
        'System Status',
        'Notify poor connection',
        self.$store.state.presentation.id,
        { nonInteraction: true },
      )
    })
  },
  async handleCurrentAudienceLogin(presentationId, editor) {
    const { currentUser } = editor.$store.state
    // let audienceData = {}
    // try {
    //   audienceData = await audienceApi.getAudienceData({
    //     presentationId,
    //   })
    // } catch (e) {
    //   console.log(e)
    //   return false
    // }
    if (currentUser && currentUser.id) {
      // storage.setValueByPresentation(presentationId, 'audienceName', currentUser.firstName)
      // storage.setValueByPresentation(presentationId, 'audienceEmail', currentUser.email)
      // editor.$store.dispatch('setAudienceInfoAction', {
      //   audienceName: currentUser.firstName,
      //   audienceEmail: currentUser.email,
      // })
    }
    // if (audienceData.audienceId) {
    //   storage.setValueByPresentation(presentationId, 'audienceId', audienceData.audienceId)
    //   storage.setValueByPresentation(presentationId, 'audienceName', audienceData.audienceName)
    //   storage.setValueByPresentation(presentationId, 'audienceEmail', audienceData.audienceEmail)
    // }
  },
  async getPresentation(pathAccesscode, editor) {
    if (!editor.uniqueAccessCode) {
      editor.isLoading = false

      return
    }

    const params = {
      connect: true,
    }
    if (pathAccesscode) {
      params.pathAccesscode = pathAccesscode
    }
    if (editor.$store.state.idSlide) {
      params.idSlide = editor.$store.state.idSlide
    }

    let dataPresentation = null
    try {
      dataPresentation = await editor.$http.get(
        Config.api.getPresentationFromCdn + editor.uniqueAccessCode,
        { params },
      )
    } catch (error) {
      editor.isLoading = false
      editor.$router.push({
        name: 'home',
        query: { error: true },
      })

      return
    }

    let presentationId = null
    if (dataPresentation.body.presentation && dataPresentation.body.presentation.id) {
      presentationId = dataPresentation.body.presentation.id
    } else {
      presentationId = dataPresentation.body.id
    }

    editor.handleResetData(dataPresentation.body)

    await this.handleCurrentAudienceLogin(presentationId, editor)

    const audienceId = storage.getValueByPresentation(presentationId, 'audienceId', Audience.generateId())
    const audienceName = storage.getValueByPresentation(presentationId, 'audienceName', '')

    const audienceEmail = storage.getValueByPresentation(presentationId, 'audienceEmail', '')
    const audienceTeam = storage.getValueByPresentation(presentationId, 'audienceTeam', '')
    const authenticationCode = storage.getValueByPresentation(presentationId, 'authenticationCode', '')
    // make sure audienceId is set to the state
    await editor.setAudienceIdAction(audienceId)
    editor.$store.state.audienceName = audienceName
    editor.$store.state.audienceEmail = audienceEmail
    editor.$store.state.audienceTeam = audienceTeam
    editor.$store.state.authenticationCode = authenticationCode

    // get audienceEmoji
    let audienceEmoji = storage.getValueByPresentation(presentationId, 'audienceEmoji')
    if (audienceEmoji) {
      editor.$store.state.isAudienceEmojiDisabled = true
    } else {
      audienceEmoji = Util.getRandomEmoji()
    }

    editor.$store.state.audienceEmoji = audienceEmoji

    if (dataPresentation.body.presentation) {
      editor._hanldeAudienceGetPresentation(dataPresentation, pathAccesscode)
      return
    }

    const urlCdn = dataPresentation.body.cacheSlideActiveUrl

    try {
      const res = await editor.$http.get(urlCdn)
      res.body = editor.tryParseBody(res.bodyText, presentationId)
      res.body.presentation = dataPresentation.body
      editor._hanldeAudienceGetPresentation(res, pathAccesscode)
      return
    } catch (error) {
      if (Sentry && error.status) {
        error.from = 'Audience get presentation'
        Sentry.captureException(JSON.stringify(error))
      }
    }

    try {
      const dataUnhandle = await editor.$http.get(
        Config.api.getPresentation + editor.uniqueAccessCode,
        { params },
      )
      editor._hanldeAudienceGetPresentation(dataUnhandle, pathAccesscode)
    } catch (error) {
      if (Sentry && error.status) {
        error.from = 'Audience get presentation unhandle'
        Sentry.captureException(JSON.stringify(error))
      }
    }
  },
}
